(function() { module.exports = this["React"]; }());


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 2
// module chunks = 0